import { state } from 'cerebral'
import * as sequences from './sequences'
import apiClient from '../../lib/util/api-client'
import schemaSettings from '../../../shared/schemas/print-order-schema'
import { createProviders } from '../providers'
import { redirectUnauthorized, createCrudState } from '../factories'
import { showFeedbackFromError } from '../feedback/factories'

const { printOrderSchema: schema } = schemaSettings
const service = apiClient.service('print-orders')

export default ({ name, app }) => {
  app.on('initialized', () => {
    const getDraftPrintOrders = app.getSequence('printOrders.getDraftPrintOrders')

    apiClient.on('login', () => {
      // Computed state is not available until next tick.
      setTimeout(getDraftPrintOrders, 0)
    })

    getDraftPrintOrders()
  })

  return {
    state: {
      ...createCrudState({ entityType: 'printOrders', storePrefix: name }),
      draftPrintOrders: [],
    },
    sequences,
    providers: createProviders({ name, service, schema }),
    catch: [
      redirectUnauthorized(),
      [
        Error,
        showFeedbackFromError({ title: 'We encountered an error' }),
        ({ props: { error, errorPath = name }, store }) => {
          store.set(state`errors.${errorPath}`, error)
        },
      ],
    ],
  }
}
